/**
 * @generated SignedSource<<fb466bbeb80313f5897907cccc880cce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionRelatedSectionRelayFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly collectionId: string;
      readonly " $fragmentSpreads": FragmentRefs<"collectionCardRelayFragment">;
    };
  }>;
  readonly " $fragmentType": "collectionRelatedSectionRelayFragment";
};
export type collectionRelatedSectionRelayFragment$key = {
  readonly " $data"?: collectionRelatedSectionRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectionRelatedSectionRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "collectionRelatedSectionRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateCollectionResultEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentPlatformTemplateCollection",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "collectionId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "collectionCardRelayFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplateCollectionContentSearchConnection",
  "abstractKey": null
};

(node as any).hash = "5bd7f55c40f6ac8524e729498ebc830d";

export default node;
